import { z } from 'zod/v4-mini';

import { GeneralBackendResponseSchema } from '$/services/mapper/authentication';
import { UserSchema } from '$/services/usecases/authentication/mapper/genericCloudResponse';

export const SignInSchema = z.pipe(
  z.object({
    ...GeneralBackendResponseSchema,
    payload: z.optional(
      z.union([
        z.object({
          user: UserSchema,
          accessToken: z.string(),
        }),
        z.object({
          regToken: z.string(),
        }),
      ]),
    ),
  }),
  z.transform((data) => ({
    message: data.message,
    ...(data?.payload && {
      ...('user' in data.payload && {
        user: data.payload.user,
        accessToken: data.payload.accessToken,
      }),
      ...('regToken' in data.payload && {
        regToken: data.payload?.regToken,
      }),
    }),
  })),
);

export type SignInResponse = z.infer<typeof SignInSchema>;
